/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as ShowcaseRouteImport } from './routes/showcase'
import { Route as RaiseRouteImport } from './routes/raise'
import { Route as QrRouteImport } from './routes/qr'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PressRouteImport } from './routes/press'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as EditorRouteImport } from './routes/editor'
import { Route as CreateRouteImport } from './routes/create'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CartRouteImport } from './routes/cart'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BusinessIndexRouteImport } from './routes/business/index'
import { Route as BusinessQuoteRouteImport } from './routes/business/quote'
import { Route as BusinessPortalRouteImport } from './routes/business/portal'
import { Route as BusinessOrdersRouteImport } from './routes/business/orders'
import { Route as BusinessCatalogRouteImport } from './routes/business/catalog'
import { Route as BusinessPortalProjectsRouteImport } from './routes/business/portal/projects'
import { Route as BusinessPortalOrdersRouteImport } from './routes/business/portal/orders'
import { Route as BusinessPortalLoginRouteImport } from './routes/business/portal/login'
import { Route as BusinessPortalCatalogRouteImport } from './routes/business/portal/catalog'
import { Route as BusinessPortalBrandsRouteImport } from './routes/business/portal/brands'
import { Route as BusinessPortalArtworkRouteImport } from './routes/business/portal/artwork'
import { Route as BusinessPortalProjectsNewRouteImport } from './routes/business/portal/projects/new'
import { Route as BusinessPortalProjectsProjectIdRouteImport } from './routes/business/portal/projects/$projectId'
import { Route as BusinessPortalOrdersOrderIdRouteImport } from './routes/business/portal/orders/$orderId'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const ShowcaseRoute = ShowcaseRouteImport.update({
  id: '/showcase',
  path: '/showcase',
  getParentRoute: () => rootRouteImport,
} as any)
const RaiseRoute = RaiseRouteImport.update({
  id: '/raise',
  path: '/raise',
  getParentRoute: () => rootRouteImport,
} as any)
const QrRoute = QrRouteImport.update({
  id: '/qr',
  path: '/qr',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PressRoute = PressRouteImport.update({
  id: '/press',
  path: '/press',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryRoute = GalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const EditorRoute = EditorRouteImport.update({
  id: '/editor',
  path: '/editor',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateRoute = CreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const CartRoute = CartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessIndexRoute = BusinessIndexRouteImport.update({
  id: '/business/',
  path: '/business/',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessQuoteRoute = BusinessQuoteRouteImport.update({
  id: '/business/quote',
  path: '/business/quote',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessPortalRoute = BusinessPortalRouteImport.update({
  id: '/business/portal',
  path: '/business/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessOrdersRoute = BusinessOrdersRouteImport.update({
  id: '/business/orders',
  path: '/business/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessCatalogRoute = BusinessCatalogRouteImport.update({
  id: '/business/catalog',
  path: '/business/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessPortalProjectsRoute = BusinessPortalProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => BusinessPortalRoute,
} as any)
const BusinessPortalOrdersRoute = BusinessPortalOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => BusinessPortalRoute,
} as any)
const BusinessPortalLoginRoute = BusinessPortalLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => BusinessPortalRoute,
} as any)
const BusinessPortalCatalogRoute = BusinessPortalCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => BusinessPortalRoute,
} as any)
const BusinessPortalBrandsRoute = BusinessPortalBrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => BusinessPortalRoute,
} as any)
const BusinessPortalArtworkRoute = BusinessPortalArtworkRouteImport.update({
  id: '/artwork',
  path: '/artwork',
  getParentRoute: () => BusinessPortalRoute,
} as any)
const BusinessPortalProjectsNewRoute =
  BusinessPortalProjectsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => BusinessPortalProjectsRoute,
  } as any)
const BusinessPortalProjectsProjectIdRoute =
  BusinessPortalProjectsProjectIdRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => BusinessPortalProjectsRoute,
  } as any)
const BusinessPortalOrdersOrderIdRoute =
  BusinessPortalOrdersOrderIdRouteImport.update({
    id: '/$orderId',
    path: '/$orderId',
    getParentRoute: () => BusinessPortalOrdersRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/create': typeof CreateRoute
  '/editor': typeof EditorRoute
  '/gallery': typeof GalleryRoute
  '/press': typeof PressRoute
  '/privacy': typeof PrivacyRoute
  '/qr': typeof QrRoute
  '/raise': typeof RaiseRoute
  '/showcase': typeof ShowcaseRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/business/catalog': typeof BusinessCatalogRoute
  '/business/orders': typeof BusinessOrdersRoute
  '/business/portal': typeof BusinessPortalRouteWithChildren
  '/business/quote': typeof BusinessQuoteRoute
  '/business/': typeof BusinessIndexRoute
  '/business/portal/artwork': typeof BusinessPortalArtworkRoute
  '/business/portal/brands': typeof BusinessPortalBrandsRoute
  '/business/portal/catalog': typeof BusinessPortalCatalogRoute
  '/business/portal/login': typeof BusinessPortalLoginRoute
  '/business/portal/orders': typeof BusinessPortalOrdersRouteWithChildren
  '/business/portal/projects': typeof BusinessPortalProjectsRouteWithChildren
  '/business/portal/orders/$orderId': typeof BusinessPortalOrdersOrderIdRoute
  '/business/portal/projects/$projectId': typeof BusinessPortalProjectsProjectIdRoute
  '/business/portal/projects/new': typeof BusinessPortalProjectsNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/create': typeof CreateRoute
  '/editor': typeof EditorRoute
  '/gallery': typeof GalleryRoute
  '/press': typeof PressRoute
  '/privacy': typeof PrivacyRoute
  '/qr': typeof QrRoute
  '/raise': typeof RaiseRoute
  '/showcase': typeof ShowcaseRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/business/catalog': typeof BusinessCatalogRoute
  '/business/orders': typeof BusinessOrdersRoute
  '/business/portal': typeof BusinessPortalRouteWithChildren
  '/business/quote': typeof BusinessQuoteRoute
  '/business': typeof BusinessIndexRoute
  '/business/portal/artwork': typeof BusinessPortalArtworkRoute
  '/business/portal/brands': typeof BusinessPortalBrandsRoute
  '/business/portal/catalog': typeof BusinessPortalCatalogRoute
  '/business/portal/login': typeof BusinessPortalLoginRoute
  '/business/portal/orders': typeof BusinessPortalOrdersRouteWithChildren
  '/business/portal/projects': typeof BusinessPortalProjectsRouteWithChildren
  '/business/portal/orders/$orderId': typeof BusinessPortalOrdersOrderIdRoute
  '/business/portal/projects/$projectId': typeof BusinessPortalProjectsProjectIdRoute
  '/business/portal/projects/new': typeof BusinessPortalProjectsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/create': typeof CreateRoute
  '/editor': typeof EditorRoute
  '/gallery': typeof GalleryRoute
  '/press': typeof PressRoute
  '/privacy': typeof PrivacyRoute
  '/qr': typeof QrRoute
  '/raise': typeof RaiseRoute
  '/showcase': typeof ShowcaseRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/business/catalog': typeof BusinessCatalogRoute
  '/business/orders': typeof BusinessOrdersRoute
  '/business/portal': typeof BusinessPortalRouteWithChildren
  '/business/quote': typeof BusinessQuoteRoute
  '/business/': typeof BusinessIndexRoute
  '/business/portal/artwork': typeof BusinessPortalArtworkRoute
  '/business/portal/brands': typeof BusinessPortalBrandsRoute
  '/business/portal/catalog': typeof BusinessPortalCatalogRoute
  '/business/portal/login': typeof BusinessPortalLoginRoute
  '/business/portal/orders': typeof BusinessPortalOrdersRouteWithChildren
  '/business/portal/projects': typeof BusinessPortalProjectsRouteWithChildren
  '/business/portal/orders/$orderId': typeof BusinessPortalOrdersOrderIdRoute
  '/business/portal/projects/$projectId': typeof BusinessPortalProjectsProjectIdRoute
  '/business/portal/projects/new': typeof BusinessPortalProjectsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cart'
    | '/checkout'
    | '/create'
    | '/editor'
    | '/gallery'
    | '/press'
    | '/privacy'
    | '/qr'
    | '/raise'
    | '/showcase'
    | '/support'
    | '/terms'
    | '/business/catalog'
    | '/business/orders'
    | '/business/portal'
    | '/business/quote'
    | '/business/'
    | '/business/portal/artwork'
    | '/business/portal/brands'
    | '/business/portal/catalog'
    | '/business/portal/login'
    | '/business/portal/orders'
    | '/business/portal/projects'
    | '/business/portal/orders/$orderId'
    | '/business/portal/projects/$projectId'
    | '/business/portal/projects/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cart'
    | '/checkout'
    | '/create'
    | '/editor'
    | '/gallery'
    | '/press'
    | '/privacy'
    | '/qr'
    | '/raise'
    | '/showcase'
    | '/support'
    | '/terms'
    | '/business/catalog'
    | '/business/orders'
    | '/business/portal'
    | '/business/quote'
    | '/business'
    | '/business/portal/artwork'
    | '/business/portal/brands'
    | '/business/portal/catalog'
    | '/business/portal/login'
    | '/business/portal/orders'
    | '/business/portal/projects'
    | '/business/portal/orders/$orderId'
    | '/business/portal/projects/$projectId'
    | '/business/portal/projects/new'
  id:
    | '__root__'
    | '/'
    | '/cart'
    | '/checkout'
    | '/create'
    | '/editor'
    | '/gallery'
    | '/press'
    | '/privacy'
    | '/qr'
    | '/raise'
    | '/showcase'
    | '/support'
    | '/terms'
    | '/business/catalog'
    | '/business/orders'
    | '/business/portal'
    | '/business/quote'
    | '/business/'
    | '/business/portal/artwork'
    | '/business/portal/brands'
    | '/business/portal/catalog'
    | '/business/portal/login'
    | '/business/portal/orders'
    | '/business/portal/projects'
    | '/business/portal/orders/$orderId'
    | '/business/portal/projects/$projectId'
    | '/business/portal/projects/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CartRoute: typeof CartRoute
  CheckoutRoute: typeof CheckoutRoute
  CreateRoute: typeof CreateRoute
  EditorRoute: typeof EditorRoute
  GalleryRoute: typeof GalleryRoute
  PressRoute: typeof PressRoute
  PrivacyRoute: typeof PrivacyRoute
  QrRoute: typeof QrRoute
  RaiseRoute: typeof RaiseRoute
  ShowcaseRoute: typeof ShowcaseRoute
  SupportRoute: typeof SupportRoute
  TermsRoute: typeof TermsRoute
  BusinessCatalogRoute: typeof BusinessCatalogRoute
  BusinessOrdersRoute: typeof BusinessOrdersRoute
  BusinessPortalRoute: typeof BusinessPortalRouteWithChildren
  BusinessQuoteRoute: typeof BusinessQuoteRoute
  BusinessIndexRoute: typeof BusinessIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/showcase': {
      id: '/showcase'
      path: '/showcase'
      fullPath: '/showcase'
      preLoaderRoute: typeof ShowcaseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raise': {
      id: '/raise'
      path: '/raise'
      fullPath: '/raise'
      preLoaderRoute: typeof RaiseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qr': {
      id: '/qr'
      path: '/qr'
      fullPath: '/qr'
      preLoaderRoute: typeof QrRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/press': {
      id: '/press'
      path: '/press'
      fullPath: '/press'
      preLoaderRoute: typeof PressRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery': {
      id: '/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof GalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/editor': {
      id: '/editor'
      path: '/editor'
      fullPath: '/editor'
      preLoaderRoute: typeof EditorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create': {
      id: '/create'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof CreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart': {
      id: '/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof CartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business/': {
      id: '/business/'
      path: '/business'
      fullPath: '/business/'
      preLoaderRoute: typeof BusinessIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business/quote': {
      id: '/business/quote'
      path: '/business/quote'
      fullPath: '/business/quote'
      preLoaderRoute: typeof BusinessQuoteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business/portal': {
      id: '/business/portal'
      path: '/business/portal'
      fullPath: '/business/portal'
      preLoaderRoute: typeof BusinessPortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business/orders': {
      id: '/business/orders'
      path: '/business/orders'
      fullPath: '/business/orders'
      preLoaderRoute: typeof BusinessOrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business/catalog': {
      id: '/business/catalog'
      path: '/business/catalog'
      fullPath: '/business/catalog'
      preLoaderRoute: typeof BusinessCatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business/portal/projects': {
      id: '/business/portal/projects'
      path: '/projects'
      fullPath: '/business/portal/projects'
      preLoaderRoute: typeof BusinessPortalProjectsRouteImport
      parentRoute: typeof BusinessPortalRoute
    }
    '/business/portal/orders': {
      id: '/business/portal/orders'
      path: '/orders'
      fullPath: '/business/portal/orders'
      preLoaderRoute: typeof BusinessPortalOrdersRouteImport
      parentRoute: typeof BusinessPortalRoute
    }
    '/business/portal/login': {
      id: '/business/portal/login'
      path: '/login'
      fullPath: '/business/portal/login'
      preLoaderRoute: typeof BusinessPortalLoginRouteImport
      parentRoute: typeof BusinessPortalRoute
    }
    '/business/portal/catalog': {
      id: '/business/portal/catalog'
      path: '/catalog'
      fullPath: '/business/portal/catalog'
      preLoaderRoute: typeof BusinessPortalCatalogRouteImport
      parentRoute: typeof BusinessPortalRoute
    }
    '/business/portal/brands': {
      id: '/business/portal/brands'
      path: '/brands'
      fullPath: '/business/portal/brands'
      preLoaderRoute: typeof BusinessPortalBrandsRouteImport
      parentRoute: typeof BusinessPortalRoute
    }
    '/business/portal/artwork': {
      id: '/business/portal/artwork'
      path: '/artwork'
      fullPath: '/business/portal/artwork'
      preLoaderRoute: typeof BusinessPortalArtworkRouteImport
      parentRoute: typeof BusinessPortalRoute
    }
    '/business/portal/projects/new': {
      id: '/business/portal/projects/new'
      path: '/new'
      fullPath: '/business/portal/projects/new'
      preLoaderRoute: typeof BusinessPortalProjectsNewRouteImport
      parentRoute: typeof BusinessPortalProjectsRoute
    }
    '/business/portal/projects/$projectId': {
      id: '/business/portal/projects/$projectId'
      path: '/$projectId'
      fullPath: '/business/portal/projects/$projectId'
      preLoaderRoute: typeof BusinessPortalProjectsProjectIdRouteImport
      parentRoute: typeof BusinessPortalProjectsRoute
    }
    '/business/portal/orders/$orderId': {
      id: '/business/portal/orders/$orderId'
      path: '/$orderId'
      fullPath: '/business/portal/orders/$orderId'
      preLoaderRoute: typeof BusinessPortalOrdersOrderIdRouteImport
      parentRoute: typeof BusinessPortalOrdersRoute
    }
  }
}

interface BusinessPortalOrdersRouteChildren {
  BusinessPortalOrdersOrderIdRoute: typeof BusinessPortalOrdersOrderIdRoute
}

const BusinessPortalOrdersRouteChildren: BusinessPortalOrdersRouteChildren = {
  BusinessPortalOrdersOrderIdRoute: BusinessPortalOrdersOrderIdRoute,
}

const BusinessPortalOrdersRouteWithChildren =
  BusinessPortalOrdersRoute._addFileChildren(BusinessPortalOrdersRouteChildren)

interface BusinessPortalProjectsRouteChildren {
  BusinessPortalProjectsProjectIdRoute: typeof BusinessPortalProjectsProjectIdRoute
  BusinessPortalProjectsNewRoute: typeof BusinessPortalProjectsNewRoute
}

const BusinessPortalProjectsRouteChildren: BusinessPortalProjectsRouteChildren =
  {
    BusinessPortalProjectsProjectIdRoute: BusinessPortalProjectsProjectIdRoute,
    BusinessPortalProjectsNewRoute: BusinessPortalProjectsNewRoute,
  }

const BusinessPortalProjectsRouteWithChildren =
  BusinessPortalProjectsRoute._addFileChildren(
    BusinessPortalProjectsRouteChildren,
  )

interface BusinessPortalRouteChildren {
  BusinessPortalArtworkRoute: typeof BusinessPortalArtworkRoute
  BusinessPortalBrandsRoute: typeof BusinessPortalBrandsRoute
  BusinessPortalCatalogRoute: typeof BusinessPortalCatalogRoute
  BusinessPortalLoginRoute: typeof BusinessPortalLoginRoute
  BusinessPortalOrdersRoute: typeof BusinessPortalOrdersRouteWithChildren
  BusinessPortalProjectsRoute: typeof BusinessPortalProjectsRouteWithChildren
}

const BusinessPortalRouteChildren: BusinessPortalRouteChildren = {
  BusinessPortalArtworkRoute: BusinessPortalArtworkRoute,
  BusinessPortalBrandsRoute: BusinessPortalBrandsRoute,
  BusinessPortalCatalogRoute: BusinessPortalCatalogRoute,
  BusinessPortalLoginRoute: BusinessPortalLoginRoute,
  BusinessPortalOrdersRoute: BusinessPortalOrdersRouteWithChildren,
  BusinessPortalProjectsRoute: BusinessPortalProjectsRouteWithChildren,
}

const BusinessPortalRouteWithChildren = BusinessPortalRoute._addFileChildren(
  BusinessPortalRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CartRoute: CartRoute,
  CheckoutRoute: CheckoutRoute,
  CreateRoute: CreateRoute,
  EditorRoute: EditorRoute,
  GalleryRoute: GalleryRoute,
  PressRoute: PressRoute,
  PrivacyRoute: PrivacyRoute,
  QrRoute: QrRoute,
  RaiseRoute: RaiseRoute,
  ShowcaseRoute: ShowcaseRoute,
  SupportRoute: SupportRoute,
  TermsRoute: TermsRoute,
  BusinessCatalogRoute: BusinessCatalogRoute,
  BusinessOrdersRoute: BusinessOrdersRoute,
  BusinessPortalRoute: BusinessPortalRouteWithChildren,
  BusinessQuoteRoute: BusinessQuoteRoute,
  BusinessIndexRoute: BusinessIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
